import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NbSelectComponent } from '@nebular/theme';

@Component({
  selector: 'ngx-item-selector',
  templateUrl: './item-selector.component.html',
  styleUrls: ['./item-selector.component.scss']
})
export class ItemSelectorComponent implements OnInit {

  @ViewChild('selector') selector: ElementRef<NbSelectComponent>;

  _originalSelected: any;
  selectedKey: string | Array<string>;


  timeoutSelection = 200;

  itemsSource: any[] = [];

  @Input()
  multi: boolean;

  @Input()
  getKey: Function;

  @Input()
  renderValue: Function;

  @Input()
  set jsonSource(value:string){
    if (value) {
      if (!value.startsWith('../assets/')) {
        value = '../assets/' + value;
      }
      this.httpClient.get(value).subscribe(d => {
        this.itemsSource = d as any[];
      });
    }
  }

  @Input()
  set dataSource(value: any[]){
    console.log(`item-selector - cargamos el dataSource ${JSON.stringify(value)}`);

    if (value) {
      this.itemsSource = value;
    }

  }

  @Input()
  set selectedData(value: any){


      console.log(`item-selector - Establecemos el valor ${JSON.stringify(value)}`);
      this._originalSelected = value;
      if(value != undefined && value != null){

        if(Boolean(this.multi)){
          if ( Array.isArray(value)){
            this.selectedKey = value.map(v => this.getId(v));
          } else {
            this.selectedKey = [this.getId(value) || ''];
          }

        } else {
          this.selectedKey = this.getId(value) || '';
        }

      }else{
        if(Boolean(this.multi)){
          this.selectedKey = [];
        } else {
          this.selectedKey = '';
        }

      }





  }


  @Output() selectedDataChange = new EventEmitter<any>();

  @Input()
  filterFunction: Function;

  constructor(private httpClient:HttpClient,private cdRef: ChangeDetectorRef){
    console.log("Construido");
  }

  ngOnInit(): void {


}

  selectionChange(event: any): void {

    if(Boolean(this.multi)){
      const selectedItems = this.itemsSource.filter(i => this.selectedKey.includes(this.getId(i)));

      if (selectedItems) {
        this.selectedKey = selectedItems.map(i => this.getId(i));  // Actualiza selectedKey para reflejar el nuevo valor
        this.selectedDataChange.emit(selectedItems);  // Emitir el nuevo valor al padre
      }
    } else {
      const selectedItem = this.itemsSource.find(i => this.getId(i) === this.selectedKey);

      if (selectedItem) {
        this.selectedKey = this.getId(selectedItem);  // Actualiza selectedKey para reflejar el nuevo valor
        this.selectedDataChange.emit(selectedItem);  // Emitir el nuevo valor al padre
      }
    }


  }


  getId(item: any): string {
    if(this.getKey != undefined){
      console.log(`item-selector - getId mediante funcion de ${JSON.stringify(item)}`);
      return this.getKey(item);
    } else {
      return item.identifier;
    }
  }

  getValue(item: any): string {
    if(this.renderValue != undefined){
      return this.renderValue(item);
    } else {
      return item.name;
    }
  }


}
